export default {
      id: "xg-mac-karti-usage",
      viewBox: "0 0 25 24",
      url: "/" + "images/icons.3.109.2.svg#xg-mac-karti-usage",
      toString: function () {
        return this.url;
      }
    }